import { ENTITY_TYPES } from '@sales-center/common'
import {
  selectAllSalesFunnels,
  useSelectFunnelStagesByType,
} from '@user/store/salesFunnel'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

export const useGetSalesFunnelData = (
  entityType: ENTITY_TYPES,
  salesFunnelId?: number,
) => {
  const unSortedSalesFunnels = useSelector(selectAllSalesFunnels)

  const salesFunnels = useMemo(() => {
    return unSortedSalesFunnels.sort((a, b) => {
      if (a.isDefault) return -1
      else if (b.isDefault) return 1
      return a.name.localeCompare(b.name)
    })
  }, [unSortedSalesFunnels])

  const defaultFunnel = useMemo(
    () => salesFunnels.filter((f) => f.isDefault).pop(),
    [salesFunnels],
  )

  const salesFunnelStages = useSelectFunnelStagesByType(
    salesFunnelId && salesFunnelId > 0
      ? salesFunnelId
      : !!defaultFunnel
      ? +defaultFunnel.id
      : -1,
    entityType,
  )

  const firstStage = useMemo(() => {
    if (
      ((salesFunnelId && salesFunnelId > 0) || !!defaultFunnel) &&
      salesFunnelStages.length >= 1
    ) {
      return salesFunnelStages[0]
    }
  }, [defaultFunnel, salesFunnelStages, salesFunnelId])

  return {
    defaultFunnel,
    firstStage,
    salesFunnels,
    salesFunnelStages,
  }
}
